// extracted by mini-css-extract-plugin
export var axis = "ScatterPlot-module--axis--4775f";
export var axisLabel = "ScatterPlot-module--axisLabel--e41b1";
export var axisLabelSecondary = "ScatterPlot-module--axisLabelSecondary--e575a";
export var container = "ScatterPlot-module--container--91b41";
export var dataPoint = "ScatterPlot-module--dataPoint--32ed5";
export var noStroke = "ScatterPlot-module--noStroke--85733";
export var path = "ScatterPlot-module--path--5a899";
export var series = "ScatterPlot-module--series--3cf8e";
export var tooltip = "ScatterPlot-module--tooltip--8d39b";